import { eachDayOfInterval, isSunday, isSaturday } from "date-fns";
import deLocale from "date-fns/locale/de";
import enLocale from "date-fns/locale/en-US";
const useDateFnsLocale = (lang) => {
  if (lang === "de")
    return deLocale;
  return enLocale;
};
const getDatesBetween = (start, end, includeWeekends) => {
  if (end >= start) {
    const dates = eachDayOfInterval({ start, end });
    if (includeWeekends) {
      return dates;
    }
    const workingDates = dates.filter((date) => !isSunday(date) && !isSaturday(date));
    return workingDates;
  }
  return [];
};
const getMaxSlots = (slotsPerDate = []) => {
  return slotsPerDate.reduce((max, obj) => Math.max(max, obj.slots.length), 0);
};
export {
  getDatesBetween,
  getMaxSlots,
  useDateFnsLocale
};
